import SplashScreen from '@/components/splash-screen/splash-screen';
import { useAuth } from '@/store/auth';
import { ReactNode } from 'react';

import { useShallow } from 'zustand/shallow';

export function AuthProvider({ children }: { children: ReactNode }) {
  const [address] = useAuth(useShallow((state) => [state.address]));

  if (!address) {
    return <SplashScreen />;
  }

  return children;
}
